module.exports = __webpack_public_path__ + "static/multi-step-service-replacement-2600aa7de6eb9dab166e5dea1759dda0.svg";